<template>
	<div class="productView">
		<div class="center" @click="onKnow(page)">
			<div class='svg' v-show="svgShow" :style="svgShow?'':'margin-top: 3.75rem;'">
				<SvgIcon :svg-name="svgName" size="60"></SvgIcon>
			</div>	
			<div class="imgAryView">
					<img class="imgView animated fadeIn" v-for="(url,num) in imgurl" :src="url" v-show="num == index">
			</div>
			
			<div style="display: flex;justify-content: space-between; width: 90%; margin: 0 auto;">
				<div >
					<div class="title">{{title}}
						<div class="Subtitle">{{Subtitle}}</div>
					</div>
				<div class="write" v-html="write">{{write}}</div>
			</div>
			<div class="know">{{know}}</div>
			</div>
		</div>
	</div>
</template>
	
<script>
	
	import SvgIcon from './SvgIcon.vue'
	
	
	
	export default{
		name:'productView',
		components:{
			SvgIcon,
		},
		props:{
			imgurl:{
				type:Array,
			},
			title:{
				type:String,
			},
			Subtitle:{
				type:String,
			},
			write:{
				type:String,
			},
			know:{
				type:String,
			},
			svgName:{ //IF UPSTYLE CGD
				type:String,
			},
			page:{
				type:String,
			}
		},
		data(){
			return{
				index:0,
			}
		},
		mounted() {
			// console.log(this.GLOBAL.imgHost);
			this.play()
		},
		methods: {
			autoplay() {
				this.index++
				if (this.index == this.imgurl.length) {
					this.index = 0
				}
			},
			play() {
				setInterval(this.autoplay, 3000)
			},
			onKnow(e) {
				console.log(e)
				window.open(e,'_self');
			}
		},
		computed:{
			svgShow(){
				console.log('this.svgName' + this.svgName);
				return this.svgName;
			}
		}
		
	}
</script>

<style>
	
	@import url("../common/animate.min.css");
	
	.center {
		margin-top: 3.75rem;
		position: relative;
	}
	
	
	
	.center .imgAryView{
		width: 90%;
		height: auto;
		/* padding-left: 5%; */
		margin-left: 5%;
		display: flex;
		flex-direction: row;
		/* overflow: auto; */
	}
	
	.center .imgAryView .imgView{
		width: 100%;
	}
	
	.center .svg {
		left: 10%;
		top:  0.75rem;
		z-index: 99;
		position:absolute;
		
	}
	
	.center .imgAryView img {
		width: 90%;
		height: 90%;
		margin: 0 auto;
		object-fit:cover; 
	}
	
	.center .title {
		/* width: 90%; */
		display: flex;
		flex-direction: row;
		height: 1.5rem;
		font-size: 1.2rem;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 600;
		color: rgba(29, 29, 29, 1);
		line-height: 1rem;
		text-align: left;
		margin: 0 auto;
		margin-top: 0.9375rem;
	}
	
	.center .title .Subtitle {
		padding-left: 0.625rem;
		font-size: 0.8rem;
		color: rgba(0, 199, 133, 1);
	}
	
	.center .write {
		font-size: 0.8rem;
		float: left;
		text-align: left;
		font-family: Alibaba-PuHuiTi-R;
	}
	
	.center .know {
		height: 1.875rem;
		font-family: Alibaba PuHuiTi;
		float: left;
		border-bottom: 1px solid;
		font-weight: 400;
		font-size:1rem;
		position:absolute;
		right: 1.2625rem;
		bottom: 0.0625rem;
		font-family: Alibaba-PuHuiTi-R;
		/* padding-top: 2.0625rem; */
		/* padding-bottom:4.0625rem; */
	}
	
</style>
